<template>
  <div class="row">
    <div class="col s12 form-wrapper">
      <div class="input-field col s12 m6">
        <select v-model="rede_social['rede_social_tipo']" id="rede_social_tipo">
          <option value="" selected disabled>Selecione</option>
          <option v-for="(rs, e) in Object.keys(meta.url_redes_sociais)" v-bind:key="e" v-bind:value="rs">{{ rs[0].toUpperCase() + rs.substr(1,) }}</option>
          <option value="other">Outro</option>
        </select>
        <label for="rede_social_tipo">Rede Social</label>
      </div>
      <div class="input-field col s12 m6">
        <input v-model="rede_social['rede_social_endereco']" id="rede_social_endereco" type="text" class="validate" />
        <label for="rede_social_endereco">Endereço</label>
      </div>
      <div class="col s12">
        <i v-if="rede_social['rede_social_tipo'] !== null" v-bind:class="`fa fa-${(['tiktok', 'other'].includes(rede_social['rede_social_tipo']) ? 'hashtag' : rede_social['rede_social_tipo'])}`"/>
        <a v-bind:disabled="!validaForm" @click="submitRedeSocial()" href="javascript:void(0)" class="btn waves-effect waves-light right">Salvar</a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FormRedesSociais',
  data (){
    return {
      meta: this.$store.state.meta.data,
      rede_social: {
        rede_social_tipo: null,
        rede_social_endereco: null
      }
    }
  },
  computed: {
    validaForm: function(){
      return(this.rede_social.rede_social_tipo === null || !this.rede_social.rede_social_endereco || this.rede_social.rede_social_endereco.length < 3 ? false : true)
    }
  },
  methods: {
    submitRedeSocial(){
      this.$emit('submitRedeSocial', this.rede_social)
    }
  },
  mounted(){
    setTimeout(() => {
      M.FormSelect.init(document.querySelectorAll('select'))
    }, 200)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/steps/contatos/FormRedesSociais.vue